import { LoadableAfterPaint } from '@confluence/loadable';

import type { FullPageEditorPresetAPI } from './ReadTime';
import type { ReadTimePopupProps } from './ReadTimePopup';

type SendContentFeaturesProps = {
	contentId: string;
	editorApi?: FullPageEditorPresetAPI | null;
	isInEditor?: boolean;
	isAbbreviatedReadTime?: boolean;
	isDetailsPanel?: boolean;
	showWordCount?: boolean;
};

export const ReadTime = LoadableAfterPaint<SendContentFeaturesProps>({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ReadTime" */ './ReadTime')).ReadTimeLoader,
});

export const ReadTimePopup = LoadableAfterPaint<ReadTimePopupProps>({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ReadTimePopup" */ './ReadTimePopup'))
			.ReadTimePopupWithErrorBoundary,
});

export { preloadReadTime } from './preloadReadTime';
